module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.7c4cbe928205c888831b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/glyphicons-halflings-regular.woff
// module id = 1958
// module chunks = 2